/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentState = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED'
} as const;
export type PaymentState = typeof PaymentState[keyof typeof PaymentState];


export function PaymentStateFromJSON(json: any): PaymentState {
    return PaymentStateFromJSONTyped(json, false);
}

export function PaymentStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentState {
    return json as PaymentState;
}

export function PaymentStateToJSON(value?: PaymentState | null): any {
    return value as any;
}

